// companyPostEditability — the ONE place that decides whether a social post (CompanyPost)
// can still be edited in the content calendar / Social Media AI page.
//
// Rule (Billy, 2026-09-04): a post that has NOT actually been published stays fully
// editable — text, image, targets AND date/time — no matter how it was created and no
// matter whether its scheduled time has already passed. Agent-created posts land at
// "now + 1 minute" and used to become uneditable once that minute passed. Only a real
// publish record locks a post.

export const LOCKED_STATUSES = ['published', 'partially_published'];

// True when the post has never been published (draft / scheduled / failed / declined).
export const isPostEditable = (post) => {
  if (!post || !post.status) return false;
  return !LOCKED_STATUSES.includes(post.status);
};

// The date picker shows for every editable post — including a draft with no
// scheduled_at yet and a scheduled post whose time has passed.
export const showsSchedulePicker = (post) => isPostEditable(post);

// Only a publish-bound save needs a future time: approving a draft, or re-saving a post
// that is already approved (its publish job is re-enqueued for the new time). A draft
// may keep a past time — it will never publish on its own.
export const requiresFutureTime = (post, action) => {
  if (action === 'schedule') return true;
  return post?.status === 'scheduled';
};
